import styles from './Slider.module.css'
import PropTypes from "prop-types";
import React, {createContext, useContext, useEffect, useRef, useState} from "react";
import useApiQuery, {ApiQueryResponse} from "../ApiQuery/UseApiQuery";
import SlideArrow from "./SlideArrow";
import SlideDotList from "./SlideDotList";
import SlideList from "./SlideList";
import useWindowSize from "../Hook/UseWindowSize";
import {useDispatch, useSelector} from "react-redux";
import {ActionMessageInt, ReduxStateInt, setTfFilter, setXFilterValue} from "../Reducer/GlobalReducer";
import TariffFilter from "../TarifFilter/TariffFilter";
import {Route, Routes, useLocation} from "react-router-dom";
import Lk from "../LK/LK";
import LoginForm from "../Auth/LoginForm/LoginForm";
import RegionChange from "../RegionChange/RegionChange";
import FullCard from "./FullCard";
import WaitLoader from "../WaitLoader/WaitLoader";
import {AppContext} from "../App";
import {useIsMobile} from "../Util/CheckMobile";
import {Subscription} from "rxjs";
import ScanRemains from "../LK/ScanRemains/ScanRemains";
import XFilterPath from "../SecondMenu/XFilterPath/XFilterPath";

interface TFilterMakeInt
{
    filterOper: any[],
    filterTether: any[],
    filterType: any[],
    sort: any[],

}
interface XFilterMakeInt
{
    val : string
}

interface SliderProps
{
    width:string;
    height: string;
    autoPlay:boolean;
    autoPlayTime:number;

}


export interface SliderContextInt
{
    goToSlide: (a:number)=>void
    changeSlide: (a:number)=>void
    slidesCount: number
    slideNumber: number
    items: { }[]

}
export const SliderContext = React.createContext<any | undefined>(undefined);
function Slider(props:SliderProps)
{
    const rxObserve = useSelector((state: ReduxStateInt) => {
        return state.rxObserve
    })
    const subscriber = useRef<Subscription>()
    const id = useRef<number>(Math.floor(Math.random()*100))


    const path = useLocation()


    const refSlider = useRef<HTMLDivElement>(null)



    const dispatch = useDispatch();

    const selectedTarif = useSelector((state:ReduxStateInt)  => {return state?.slider?.selectedTarif})
    const xFilter = useSelector((state:ReduxStateInt)  => {return state?.xFilter})


//    const {regionId,macroRegionId} = useSelector((state:ReduxStateInt)  => {return state.baseRegion} )
    const baseRegion = useSelector((state:ReduxStateInt)  => {return state.baseRegion} )
    const tfFilter = useSelector((state:ReduxStateInt)  => {return state.tarifFilter} )
    const containerRef = useRef<HTMLDivElement>(null)

    const mode = useSelector((state:ReduxStateInt)  => {return state.slider.sliderMode} )

    const [refresh, setRefresh] = useState(0)

    const isMobile = useIsMobile()
    const listData = useRef<{
        regionId?:number
        macroRegionId?: number
        xFilter?:string

    }>()

    const [ldrData,rsDataItem,exLoadData] = useApiQuery("/tarif/list","post",listData);


    const [baseData, setBaseData] = useState<any[]>([])

    const [slide, setSlide] = useState(0);

    const [startData, setStartData] = useState(false)

    const [itemListLength, setItemListLength] = useState(0)

    const [width, height] = useWindowSize();



    const [screenSlideCount,setScreenSlideCount] = useState(Number(getComputedStyle(document.documentElement).getPropertyValue('--slide-cnt')))
    const [itemList, setItemList] = useState<any[][]>([]);

    const oldScrollY = useRef(0)
    const scrollDy = useRef({
        dir:0,
        dy:0
    })

    let k=0


    useEffect(() => {
        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    }, []);


    useEffect(()=>{
        if(subscriber.current)
        {
            try {
                subscriber.current?.unsubscribe()
            } catch (e) {

            }
        }
        subscriber.current = rxObserve.subscribe((e)=>messageMake(e))
        return ()=>{
            //console.log(`Slider ${id.current} remove subscriber`)
            if(subscriber.current)subscriber.current?.unsubscribe()
        }
    })

    useEffect(()=>{
        const slideCnt =Number(getComputedStyle(document.documentElement).getPropertyValue('--slide-cnt'))
        let cnt = slideCnt
        if(tfFilter.active && slideCnt >2 ) cnt = slideCnt -1
        setScreenSlideCount( cnt)
        //setScreenSlideCount.(cnt)
    },[width,tfFilter])

    useEffect(()=>{
        setItemList(chunkArray(baseData, screenSlideCount))
        setSlide(0)

    },[screenSlideCount])

    useEffect(()=>{
        if(!tfFilter.active)
                rxObserve.next({
                message: "tFilter-reset",
            })
    },[tfFilter.active])

    useEffect(()=>{
        if(!xFilter.active)
            rxObserve.next({
                message: "xFilter-reset",
            })
//        if(containerRef.current)containerRef.current.scrollIntoView()
//        window.scrollTo(0,0)
    },[xFilter.active])


    //Загрузка по изменению data
    useEffect(() => {
        loadData()
    }, [listData,baseRegion]);



    // применяем фильтр когда загружены базовые данные
    useEffect(()=>{
        let xBaseData = baseData
        if(path?.pathname)
        {
            const valReg = path?.pathname?.match(/(?<=xfilter\/).*$/) //Тут же применяем Х фильтр если адрес есть
            if(valReg)
            {
                 xBaseData = filterXData(baseData, {val: valReg[0]})

            }
        }



        setItemList (chunkArray(xBaseData,screenSlideCount))
        setSlide(0)

    },[baseData])


/*    useEffect(()=>{
        messageMake({
            message: "xFilter-make",
            data: "m1s"
        })
    },[path]) */


    const handleScroll = () => {
//        console.log("old, new", oldScrollY.current,window.scrollY)
        const yThreshold = -20
        const dyThreshold = 50
        const dy = Math.abs(window.scrollY - oldScrollY.current)
        if(window.scrollY > oldScrollY.current) {
            k=1

        } else {
            k=0
        }
        if(scrollDy.current)
        {
            scrollDy.current.dy+=dy

            if(scrollDy.current.dir !== k)
            {
                scrollDy.current ={dir: k === 0 ? 0: 1,dy: 0}
            }
        }
        //console.log(scrollDy.current)
        oldScrollY.current = window.scrollY;
        //console.log("k dir",k)
        if(containerRef.current)
        {
            const y =  containerRef.current.getBoundingClientRect().y
//            console.log(y,k)
            if(y < yThreshold && k===0)
                if(scrollDy.current && scrollDy.current.dy > dyThreshold)
                {
                    rxObserve.next({
                        message: "xFilter-stick"
                    })

                }
            if(k===1 || y >= yThreshold)
            {
                rxObserve.next({
                    message: "xFilter-normal"
                })

            }

        }
    }

    const messageMake = (message: ActionMessageInt) =>{
        //console.log(message)
        if(message?.message?.match(/tFilter-reset/ui) || message?.message?.match(/xFilter-reset/ui))
        {
            setItemList(chunkArray(baseData, screenSlideCount))
            setSlide(0)
            return
        }
        if(message?.message?.match(/tFilter-make/ui))
        {
            const x = filterData(baseData, message?.data)
            setItemList(chunkArray(x, screenSlideCount))
            setSlide(0)
            return

        }
        if(message?.message?.match(/xFilter-make/ui))
        {
            const x = filterXData(baseData, message?.data)
            //console.log("filter", x)
            setItemList(chunkArray(x, screenSlideCount))
            setSlide(0)
            return
        }

        if(message?.message?.match(/slider-view/ui))
        {
            console.log("move Slider up")
            if(refSlider.current)refSlider.current.scrollIntoView()
        }


    }


    //!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!

    const filterData = (data:any[], filter:TFilterMakeInt):any[] =>{
        if(data?.length === 0)return data


        const filteredData = data?.filter((item)=>{
            if(! filterByOPerId(item?.operId,filter)) return false
            if(! filterBySimType(item?.type,filter)) return false
            if(! filterByTether(item?.optList,filter)) return false
            return true

        })
        if(filter?.sort?.length)
        {
            const sortedData = filteredData?.sort((a:any,b:any)=>{
                let x,y

                switch (filter?.sort[0]?.id)
                {
                    case 0:
                        try {
                            x = Number(a?.apList[0].val)
                            y = Number(b?.apList[0].val)

                        } catch (e) {
                            //console.log(e)
                            return 0
                        }
                        //console.log(`${x} ${y} - 0`)
                        if(x>y) return 1
                        if(x<y) return -1
                        return 0
                    case 1:
                        try {
                            x = Number(a?.packetList[0].val)
                            y = Number(b?.packetList[0].val)
                            //console.log(`${x} ${y} - 1`)

                        } catch (e) {
                            //console.log(e)
                            return 0
                        }
                        if(x>y) return -1
                        if(x<y) return 1
                        return 0
                    case 2:
                        try {
                            x = Number(a?.netList[0].val)
                            y = Number(b?.netList[0].val)
                            //console.log(`${x} ${y} - 2`)

                        } catch (e) {
                            //console.log(e)
                            return 0
                        }
                        if(x>y) return -1
                        if(x<y) return 1
                        return 0
                    default:
                        //console.log("default")
                        return 0

                }
            })
            return sortedData

        }
        //console.log("filtered tFilter data",filteredData)
        return  filteredData
    }

    //!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
    const filterXData = ( data : any[], filter:XFilterMakeInt):any[] =>{

        //console.log("call filterXData for data ",data, filter)
        if(! data.length) return data
        //console.log("x",filter?.val?.length)
        if(!filter?.val?.length) {
            return data
        }

        //console.log("apply xFilter")
        const filteredData = baseData?.filter((item)=>{
            if(item?.xFilter && item?.xFilter.length)
            {
                const regExp = new RegExp(filter?.val+";",'ui')
                if(item?.xFilter?.match(regExp)) return true
                return false
            }
            return false
        })
        //console.log("filtered xFilter data",filteredData)
        return filteredData
    }


    //!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!

    const filterByOPerId = (val:any, filter:TFilterMakeInt)=>{
        if(val === undefined) return false
        if(filter.filterOper.length === 0) return true
        const flVal= filter?.filterOper?.reduce((acc, item:string)=>{
            const pattern =new RegExp("("+item?.toString()+")","ui")
            if(val.match(pattern))acc = true
            return acc;
        }, false)
        return flVal
    }
    const filterByTether = (val:any, filter:TFilterMakeInt)=>{
        if(val === undefined) return false
        if(filter.filterTether.length === 0) return true
        const flVal= filter.filterTether.reduce((acc, item:number)=>{
            if(item === 1 && !val.match(/tt;/ui)) acc = true
            if(item === 0 && val.match(/tt;/ui)) acc = true
            return acc;
        }, false)
        return flVal
    }
    const filterBySimType = (val:any, filter:TFilterMakeInt)=>{
        if(val === undefined) return false
        if(filter.filterType.length === 0) return true
        const flVal= filter.filterType.reduce((acc, item:number)=>{
            const fVal = Number(val)
            if(fVal === item ) acc = true
            return acc;
        }, false)
        return flVal

    }

    //!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!






    const chunkArray = (arr:any[],chunkSize=1) =>{
        //console.log(`chunk ${chunkSize}`)
        setItemListLength(Array.isArray(arr) ? arr?.length : 0)
        const result=[];
        let cnt =0
        for(let i=0;i<arr.length;i+=chunkSize) {
            const itm = arr.slice(i,i+chunkSize)
            const x = itm?.map((item)=>{

                return {...item, num:cnt++}
            })
            result.push(x);
        }
        return result;
    }

    //Загрузка
    function loadData()
    {
        listData.current = {
            macroRegionId: baseRegion?.isChanged ? baseRegion?.macroRegionId : undefined,
            regionId: baseRegion?.isChanged ? baseRegion?.regionId : undefined
        }


        exLoadData().then((e)=>{
            if(e?.success)
            {
                setBaseData(e.payload)
                setItemList(chunkArray(e.payload, screenSlideCount))
                setStartData(true)
                dispatch(
                    dispatch(setTfFilter({
                        ...tfFilter,
                        active: false,
                        appliedFilter: false,
                        filterOper: [],
                        filterTether: [],
                        filterType: [],
                        sort: [],
                    }))
                )

                dispatch(setXFilterValue({
                    val:"",
                    active: false
                }))

            }
        })
    }




    /*if(mode===1) return(
        <SliderContext.Provider
            value={{
                //setMode,
            }}>

            <FullCard tarifId={selectedTarif ? selectedTarif : "" }/>
        </SliderContext.Provider>
    )*/
    //if(!rsDataItem.success) return null
    return(
        <WaitLoader loading={ldrData} api={rsDataItem} onlyLoading={true}>
            <div className={styles.sliderContainer} ref={containerRef}>
                <TariffFilter/>
                <div className= {styles.slider} ref={refSlider}>
                    <SliderContext.Provider
                        value={{
                            slidesCount: itemListLength,
                            slideNumber: slide,
                            screenSlideCount: screenSlideCount,
                            itemList: itemList,
                        }}>
                        {startData && <SlideList/>}
                    </SliderContext.Provider>
                </div>
            </div>
        </WaitLoader>
    )
}
export default Slider




